import { Flex } from "@daangn/carotene";
import { atoms } from "@daangn/carotene/css";
import clsx from "clsx";
import type { ReactNode } from "react";

import * as css from "./FilterChipList.css";
import { FormChipAnchor } from "./FormChip";

interface FilterChipListProps {
  children: ReactNode;
  className?: string;
}

export const FilterChipList = ({
  children,
  className,
}: FilterChipListProps) => {
  return (
    <Flex
      alignItems="center"
      gap={2}
      className={clsx(css.filterChipsContainer, className)}
    >
      <ul
        className={atoms({
          display: "flex",
          gap: 2,
        })}
      >
        {children}
      </ul>
    </Flex>
  );
};

interface FilterChipItemProps extends React.HTMLAttributes<HTMLLIElement> {}
export const FilterChipItem = ({ children, ...props }: FilterChipItemProps) => {
  return (
    <li
      className={atoms({
        display: "inlineFlex",
        justifyContent: "center",
        alignItems: "center",
      })}
      {...props}
    >
      {children}
    </li>
  );
};

type FilterChipProps = {
  label: string;
  href: string;
};
export const FilterChip = ({ label, href, ...props }: FilterChipProps) => {
  return (
    <FormChipAnchor
      href={href}
      selected
      closeIcon
      className={css.filterChip}
      {...props}
    >
      {label}
    </FormChipAnchor>
  );
};
